import React from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';
import { SPAIN_PROVINCES } from '@/utils/provinces.ts';

interface ProvincesSelectorProps {
  value: string[];
  onChange: (provinces: string[]) => void;
  disabled?: boolean;
  label?: string;
}

const ProvincesSelector: React.FC<ProvincesSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  label = 'Provincias en las que operas',
}) => (
  <Autocomplete
    multiple
    options={SPAIN_PROVINCES}
    value={value}
    onChange={(_e, newValue: string[]) => onChange(newValue)}
    renderTags={(value: string[], getTagProps) =>
      value.map((option: string, index: number) => (
        <Chip variant="outlined" label={option} {...getTagProps({ index })} key={index} />
      ))
    }
    renderInput={(params) => <TextField {...params} label={label} placeholder="Selecciona..." />}
    fullWidth
    disabled={disabled}
  />
);

export default ProvincesSelector;
